import infoIcon from "@assets/actions/info.svg";
import NewsletterImage from "@assets/footer/newsletter.webp";
import tooltipBgDesktop from "@assets/images/TooltipBgDesktop.svg";
import tooltipBgMobile from "@assets/images/TooltipBgMobile.svg";
import { NEWSLETTER_MESSAGES } from "@config/NewsletterFormConstants";
import Heading from "@elements/Typography/Heading";
import fetchTMApi from "@helper/fetchTMApi";
import { getValidEmailRegex } from "@helper/utils";
import useWindowDimensions from "@hooks/useWindowDimensions";
import { NewsletterPostResponse } from "@typings/Newsletter";
import { FormEvent, useEffect, useState } from "react";
import { Link } from "react-router";

export const FooterNewsletterSignup = () => {
  const [email, setEmail] = useState<string>("");
  const [isMarketingChecked, setIsMarketingChecked] = useState(false);
  const [successMsg, setSuccessMsg] = useState<string>("");
  const [errorMsg, setErrorMsg] = useState<string>("");
  const { width } = useWindowDimensions();

  useEffect(() => {
    if (errorMsg.length > 0 || successMsg.length > 0) {
      setTimeout(() => {
        setErrorMsg("");
        setSuccessMsg("");
      }, 3000);
    }
  }, [errorMsg, successMsg]);

  async function handleOnSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    e.stopPropagation();
    const isEmailValid = email && getValidEmailRegex().test(email);

    if (!isEmailValid) {
      setErrorMsg(NEWSLETTER_MESSAGES.INVALID_EMAIL);
      return;
    }

    try {
      const queryParams = new URLSearchParams({
        email,
        isMarketingChecked: String(isMarketingChecked),
      }).toString();
      const res = await fetchTMApi(`newsletterSignup?${queryParams}`, "GET");
      const data = (await res) as NewsletterPostResponse;
      console.log("DATA", data);
      if (data.msg) {
        setErrorMsg(""); // unset error message
        setSuccessMsg(data.msg);
        return;
      }

      if (data.errorMsg) {
        setErrorMsg(data.errorMsg);
        return;
      }
    } catch (e: unknown) {
      setErrorMsg(NEWSLETTER_MESSAGES.FAILED);
      console.log("failed with error: ", e);
      return;
    }
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };
  const handleMarketingChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsMarketingChecked(e.target.checked);
  };

  const getLeftClasses = (width: number) => {
    if (width <= 320) return "-left-[200px] w-fit";
    if (width <= 375) return "-left-[160px] w-fit";
    if (width >= 531 && width <= 600) return "-left-[210px] w-fit";
    if (width <= 768) return "-left-[140px]";
    if (width <= 1024) return "-left-[116px]";
    return "left-full ml-2";
  };

  return (
    <div className="lg:flex xl:max-w-xl lg:max-w-lg md:max-w-full sm:max-w-full w-full mx-auto py-4 pt-500 xs:px-sm xl:px-xxs font-primary max-h-fill lg:max-h-[410px] xl:max-h-[365px] border-gray-2200 border-b">
      <div className="inline-block md:w-8/12">
        <Heading
          Element="h2"
          className="text-red-100 text-3md leading-450 font-regular mb-2"
        >
          எங்களுடன் இணைந்திருங்கள்!
        </Heading>
        <p className="w-full font-normal text-sm leading-400 text-gray-100 mt-3 mb-3">
          மின்னஞ்சல் பதிவு செய்வதன் மூலம் செய்திகள், நிகழ்ச்சிகள் மற்றும் பல
          தகவல்களை மின்னஞ்சல் வழி பெறுவீர்கள்!
        </p>
        {errorMsg ? (
          <div className="w-full py-3 px-5 mb-4 border border-solid border-red-200 rounded text-white-300 bg-pink-100 text-xs font-normal leading-800">
            {errorMsg}
          </div>
        ) : successMsg ? (
          <div className="w-full py-3 px-5 mb-4 border border-solid border-green-200 rounded text-green-300 bg-green-100 text-xs font-normal leading-800">
            {successMsg}
          </div>
        ) : (
          <form
            onSubmit={(e: FormEvent<HTMLFormElement>) => void handleOnSubmit(e)}
          >
            <input
              id="enter-email"
              name="enter-email"
              onChange={handleInputChange}
              type="email"
              className="lg:h-[42px] rounded-[5px] lg:rounded-l-[5px] p-[10px] w-full lg:w-[416px] font-normal text-xs"
              placeholder="மின்னஞ்சல் முகவரியை இங்கு பதிவிடுக!"
            />

            <div className="w-full font-normal text-xs leading-400 text-gray-100 mt-3 mb-3">
              இதற்குப் பதிவு செய்வதன்வழி, அவ்வப்போது மாறுதலுக்கு உள்ளாகும்
              எஸ்பிஎச் மீடியா நிறுவனத்தின்{" "}
              <Link
                reloadDocument
                className="text-red-100 hover:text-red-200 hover:underline"
                to={"https://www.sph.com.sg/tnc/website"}
                target="_blank"
              >
                விதிமுறைகள் மற்றும் நிபந்தனைகள்
              </Link>{" "}
              மற்றும்{" "}
              <Link
                reloadDocument
                className="text-red-100 hover:text-red-200 hover:underline"
                to={"https://www.sph.com.sg/tnc/privacy"}
                target="_blank"
              >
                தனியுரிமைக் கொள்கை
              </Link>{" "}
              யையும் ஏற்றுக்கொள்கிறேன்.
            </div>
            <div className="flex items-center my-4 space-x-2">
              <input
                name="consent-email"
                id="consent-email"
                type="checkbox"
                onChange={handleMarketingChange}
                className="appearance-auto h-3 w-3 text-blue-400 border-blue-400 rounded focus:ring-blue-500"
              />
              <label
                htmlFor="consent-email"
                className="xl:flex gap-1 items-center text-xs text-gray-100"
              >
                ஆம், விளம்பரத் தகவல்களையும் சலுகைகளையும் பெற விரும்புகிறேன்.
                <div className="relative group inline-block">
                  {/* Info icon */}
                  <img
                    src={infoIcon}
                    alt="info"
                    width={12}
                    className="cursor-pointer ml-1 xl:ml-0"
                  />

                  {/* Tooltip Desktop*/}
                  <div
                    className={`absolute z-10 -top-16
                      ${getLeftClasses(width)}
                      lg:top-1/2 lg:left-full -translate-y-1/2 rounded-md lg:ml-1
                w-[245px] h-[130px] lg:w-[235px] lg:h-[110px] px-2 pt-2 pb-[19.5px] lg:py-[6px] lg:pl-[18px] lg:pr-[6px]
                invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-all duration-300`}
                    style={{
                      backgroundImage: `url(${width <= 992 ? tooltipBgMobile : tooltipBgDesktop})`,
                      backgroundSize: "cover",
                    }}
                  >
                    <div className="w-[200px] lg:w-[210px] pl-2 text-gray-100 text-3xs leading-[150%]">
                      எஸ்பிஎச் மீடியா லிமிடெட், அதைச் சார்ந்த நிறுவனங்கள், இணை
                      நிறுவனங்கள் மற்றும் அவற்றின் முகவர்கள், அங்கீகாரம் பெற்ற
                      சேவை வழங்குநர்கள்.
                    </div>
                  </div>
                </div>
              </label>
            </div>
            <button className="text-[white] bg-[linear-gradient(90deg,_#F4A63B_0%,_#F5740A_100%)] h-[40px] lg:h-[42px] mt-2 lg:mt-0 w-full lg:w-[150px] p-[10px 20px] rounded-[5px] rounded-r-[5px]">
              அனுப்பு
            </button>
          </form>
        )}
      </div>
      <div className="hidden lg:block lg:px-3.5 xs:py-xs lg:pb-xs md:px-sm text-sm not-italic leading-200 tracking-normal text-gray-100 md:w-4/12 lg:translate-y-[-110px] md:inline-block md:pr-0 md:translate-y-0 md:h-auto">
        <img
          alt="newsletter-footer-image"
          className="w-[290px] h-[325px]"
          src={NewsletterImage}
        />
      </div>
    </div>
  );
};
